"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _ActionButtons = _interopRequireDefault(require("../common/ActionButtons"));
var _ModalInternalContext = require("./ModalInternalContext");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var HBModalActions = function HBModalActions(_ref) {
  var align = _ref.align,
    sticky = _ref.sticky,
    primaryAction = _ref.primaryAction,
    secondaryAction = _ref.secondaryAction;
  var _useModalInternalCont = (0, _ModalInternalContext.useModalInternalContext)(),
    getTestIdProps = _useModalInternalCont.getTestIdProps;
  var primaryActionWithTestIds = primaryAction && _objectSpread(_objectSpread({}, primaryAction), getTestIdProps('secondary'));
  var secondaryActionWithTestIds = secondaryAction && _objectSpread(_objectSpread({}, secondaryAction), getTestIdProps('primary'));
  return /*#__PURE__*/_react["default"].createElement(_ActionButtons["default"], {
    align: align,
    sticky: sticky,
    primaryAction: primaryActionWithTestIds,
    secondaryAction: secondaryActionWithTestIds
  });
};
var _default = exports["default"] = HBModalActions;
//# sourceMappingURL=HBModalActions.js.map